import React from "react";
import "./WelcomeModal.scss";

import Button from "components/uiComponents/Button";

import WelcomeImg from "static/images/welcome_img.svg"

const WelcomeModal = ({
  onActionClick,
}) => {
  return (
    <div className="welcome-modal">
      <img
        className="welcome-modal_img"
        src={WelcomeImg}
      />

      <div
        className="welcome-modal__content"
      >
        <p
          className="welcome-modal__content_title"
        >
          Welcome to BIMSearch!
        </p>

        <p
          className="welcome-modal__content_text"
        >
          Use BIMSearch to instantly pull data from<br /> any Autodesk BIM 360 model: any time, any place.
        </p>

        <p
          className="welcome-modal__content_text"
        >
          Take a look at the sample project and see what<br /> BIMSearch has to offer!
        </p>
      </div>

      <div
        className="welcome-modal__button_container"
      >
        <Button
          clickFunction={onActionClick}
        >
          Let's start!
        </Button>
      </div>
    </div>
  );
};

export default WelcomeModal;
